import Panel from "../../entities/Panel/Panel";
import { EnumEventBus, eventBus } from "../EventBus";
import PractiseButtonManager from "./PractiseButtonManager/PractiseButtonManager";
import DrawingToolsManager from "./DrawingToolsManager/DrawingToolsManager";
import TestButtonManager from "./TestButtonManager/TestButtonManager";
import FlipAnimation, { FlipAnimationOpts } from "../../../../../../src/animation/FlipAnimation";
import { QuestionMode } from "../../types/Enum";


export default class PanelManager {
  private Panel = new Panel();
  private DrawingToolManager = new DrawingToolsManager();
  private PractiseButtonManager = new PractiseButtonManager();
  private TestButtonManager = new TestButtonManager();

  constructor() {
    this.TestButtonManager.visible = false;
    eventBus.on(EnumEventBus.setQuestMode, async (mode: QuestionMode) => this.setQuestMode(mode));
  }
  async setQuestMode(mode: QuestionMode) {
    await this.flip(1, 0);
    this.PractiseButtonManager.visible = mode === QuestionMode.practise;
    this.TestButtonManager.visible = mode === QuestionMode.test; 
    await this.flip(0, 1);
  }
  async flip(startVal: number, targetVal: number): Promise<void> {
    const setPanelScale = (v: number) => this.Panel.scale.set(v, 1);
    const flipOpt: FlipAnimationOpts = { startVal, targetVal, duration: 200 };
    return new Promise(resolve => { new FlipAnimation(flipOpt, setPanelScale, resolve) });
  }
}



